import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenStanchionDto } from 'models/pen/PenStanchion';
import { PenStanchionService } from 'services/pen/pen-stanchion-service';

@autoinject
export class PenStanchionList {
  protected tableData: Array<PenStanchionDto>;
  protected activeTableRow: number;

  protected tableHeaders: TableHeader<PenStanchionDto>[] = [
    { key: 'Name', label: 'general.name', sortable: true },
    { key: 'Type', label: 'general.type', sortable: true },
    { key: 'Height', label: 'general.height', sortable: true },
  ];

  constructor(
    private eventAggregator: EventAggregator,
    protected fm: FilterManager,
    protected penStanchionService: PenStanchionService,
    private pubsub: PubSub
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('penStanchionReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    this.fm.init({
      context: 'pen-stanchion-list',
      storageKey: 'pen-stanchion-list',
      filters: {
        //TODO
      } satisfies Filters,
      defaultFilters: {
        //TOD
      },
    });

    this.updateView();
  }

  @AsyncErrorHandler
  async updateView() {
    const response = await this.penStanchionService.getPenStanchionss(this.fm.queryFilter);

    if (!response) return;
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

    this.tableData = response.data;
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
